// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"983":"5f23e8b9fd735c01","2277":"14920877ae4eaaf7","5701":"25e0b54463c4ebe2","8761":"7b71cf8df4e76bbe"}[chunkId] + ".css";
};